namespace Nobox.Pages {
    export interface FilterDateClass {
        fDate?: string;
        lDate?: string;
    }
}
